import styled from 'styled-components';

const Content = styled.div`
  position: relative;
  max-width: 1150px;
  height: calc(100vh - 220px);
  margin: 2rem auto 0;
`;

export default { Content };
